import React, { useContext } from 'react'
import Link from 'next/link'
import { LocationContext } from '../../context/LocationContext'

export const BlogHeaderLinks = () => {
    const { countryCd } = useContext(LocationContext)

  return (
        <div className='bg-gray-800 text-white py-10 px-2'>
                <ul className="max-w-5xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-6 text-center text-sm md:text-base">
                        <li>
                                <Link href={`/${countryCd}/blogs/health-fitness`} className='text-orange-500'>
                                        Health and Fitness
                                </Link>
                        </li>
                        <li>

                                <Link href={`/${countryCd}/blogs/finance-insurance-investment`} className='text-orange-500'>
                                Finance
                                </Link>
                        </li>
                        <li>
                                <Link href={`/${countryCd}/blogs/housing`} className='text-orange-500'>
                                        Housing
                                </Link>
                        </li>
                        <li>
                                <Link href={`/${countryCd}/blogs/hvac-services`} className='text-orange-500'>
                                        HVAC Services
                                </Link>
                        </li>
                        <li>
                                <Link href={`/${countryCd}/blogs/repair-renovation`} className='text-orange-500'>
                                        Home Repair
                                </Link>
                        </li>
                        <li>
                                <Link href={`/${countryCd}/blogs/house-keeping`} className='text-orange-500'>
                                        House Keeping
                                </Link>
                        </li>
                        <li>
                                <Link href={`/${countryCd}/blogs/beauty-wellness`} className='text-orange-500'>
                                        Beauty
                                </Link>
                        </li>
                        <li>
                                <Link href={`/${countryCd}/blogs/local`} className='text-orange-500'>
                                        Local
                                </Link>
                        </li>
                {/* <Link href="/blogs/travel">
                        <a className='text-orange-600'>
                        <h2>Travel</h2>
                        </a>
                </Link>
                <Link href="/blogs/beauty-fashion">
                        <a className='text-orange-600'>
                        <h2>Beauty and Fashion</h2>
                        </a>
                </Link> */}
                </ul>
        </div>
  )
}
